import { jsx as _jsx } from "react/jsx-runtime";
import PartialSetup from "./PartialSetup";
const DeleverageSetup = ({ setup, title }) => {
    return (_jsx(PartialSetup, { setup: setup, title: title, extra: _jsx("div", { className: "flex flex-row items-center py-2", children: _jsx("pre", { children: `Bot force enabled: ${setup.botForceEnabled ? "yes" : "no"}` }) }) }));
};
export default DeleverageSetup;
